// fonts
import "./assets/fonts/DB-Helvethaica-X-Bd-v3.2.ttf";
import "./assets/fonts/DB-Helvethaica-X-Blk-v3.2.ttf";
import "./assets/fonts/DB-Helvethaica-X-It-v3.2.ttf";
import "./assets/fonts/DB-Helvethaica-X-Li-v3.2.ttf";
import "./assets/fonts/DB-Helvethaica-X-Med-v3.2.ttf";
import "./assets/fonts/DB-Helvethaica-X-Thin-v3.2.ttf";
import "./assets/fonts/DB-Helvethaica-X-UlLi-v3.2.ttf";
import "./assets/fonts/DB-Helvethaica-X-v3.2.ttf";
import "./assets/fonts/Kanit-BoldItalic.ttf";
import "./assets/fonts/Kanit-Medium.ttf";

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./assets/styles/styles.css";
import App from "./App";
import AppNotLine from "./AppNotLine";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./services/Store";
import { LiffProvider } from "react-liff";
import registerServiceWorker from "./registerServiceWorker";


function fnHandleLiff(liff) {
  // console.log("error", liff.error);
}
const path = window.location.pathname;
const liffId = process.env.REACT_APP_LIFF_ID; // prod

let isLoginBrowser = true;
const RouteNotAuth = [
  "/otp",
  "/liff-basic",
  "/questionnaire-preview",
  "/asset",
  "/article-point",
];
const root = ReactDOM.createRoot(document.getElementById("root"));

if (RouteNotAuth.includes(window.location.pathname)) {
  root.render(
    <Provider store={store}>
      <BrowserRouter>
        <AppNotLine />
      </BrowserRouter>
    </Provider>
  );
} else {
  root.render(
    <Provider store={store}>
      <BrowserRouter>
        <LiffProvider
          liffId={liffId}
          withLoginOnExternalBrowser={isLoginBrowser}
          callback={fnHandleLiff}
        >
          <App />
        </LiffProvider>
      </BrowserRouter>
    </Provider>
  );
}

reportWebVitals();
registerServiceWorker();
